import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { postRequest } from "services/api";
import {
  DataGridPremium,
  useGridApiRef,
  GRID_DETAIL_PANEL_TOGGLE_FIELD,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
  GridToolbarExport,
} from "@mui/x-data-grid-premium";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  OutlinedInput,
  Select,
  Snackbar,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import DateRangePicker from "react-bootstrap-daterangepicker";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { Link } from "react-router-dom";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckIcon from "@mui/icons-material/Check";

const columns = [
  {
    field: "CustomerName",
    headerClassName: "headingbg-color",
    headerName: "Customer Name",
  },
  {
    field: "CustomerOrderNumber",
    headerClassName: "headingbg-color",
    headerName: "Customer Order",
  },
  {
    field: "IGDOrderNumber",
    headerClassName: "headingbg-color",
    headerName: "IGD Order",
  },

  {
    field: "CustomerPOnumber",
    headerClassName: "headingbg-color",
    headerName: "Customer PO Number",
  },
  {
    field: "orderStatus",
    headerClassName: "headingbg-color",
    headerName: "Order status",
  },
  {
    field: "ShipToName",
    headerClassName: "headingbg-color",
    headerName: "Ship To Name",
  },
  {
    field: "ShipToAddress",
    headerClassName: "headingbg-color",
    headerName: "Ship To Address",
  },
  {
    field: "BillToName",
    headerClassName: "headingbg-color",
    headerName: "Bill To Name",
  },
  {
    field: "OrderShipDate",
    headerClassName: "headingbg-color",
    headerName: "Order Start Ship Date",
  },
  {
    field: "OrderCancelDate",
    headerClassName: "headingbg-color",
    headerName: "Order Cancel After Date",
  },
  {
    field: "QtyOrdered",
    headerClassName: "headingbg-color",
    headerName: "Quantity Ordered",
    type: "number",
    groupable: false,
  },
  {
    field: "PcsOrdered",
    headerClassName: "headingbg-color",
    headerName: "Pieces Ordered",
    type: "number",
    groupable: false,
  },
  {
    field: "TotalCube",
    headerClassName: "headingbg-color",
    headerName: "Total Cube",
    type: "number",
    groupable: false,
  },
  {
    field: "TotalWeight",
    headerClassName: "headingbg-color",
    headerName: "Total Weight",
    type: "number",
    groupable: false,
  },
  {
    field: "GroupingNumber",
    headerClassName: "headingbg-color",
    headerName: "Grouping Number",
  },
  {
    field: "RoutingNotesWithTMS",
    renderCell: (params) => {
      if (params.value) {
        const dataArray = params.value.split("~");

        return (
          <Link href="#" title={dataArray[0].toString()}>
            {dataArray[0].toString()}
          </Link>
        );
      } else {
        return params.value && params.value.toString();
      }
    },
    headerClassName: "headingbg-color",
    headerName: "Routing Notes",
  },
  {
    field: "DateEnteredForRouting",
    headerClassName: "headingbg-color",
    headerName: "Date Entered for Routing",
  },
  {
    field: "LoadNumber",
    headerClassName: "headingbg-color",
    headerName: "Load Number",
  },
  {
    field: "ExternalLoadNumber",
    headerClassName: "headingbg-color",
    headerName: "External Load Number",
  },
  {
    field: "BOLNotes",
    headerClassName: "headingbg-color",
    headerName: "BOL Notes",
  },
  {
    field: "AppointmentNumber",
    headerClassName: "headingbg-color",
    headerName: "Appointment Number",
  },
  {
    field: "AppointmentDateTime",
    headerClassName: "headingbg-color",
    headerName: "Appointment Time",
  },
  {
    field: "SCAC",
    headerClassName: "headingbg-color",
    headerName: "SCAC",
  },
  {
    field: "CarrierName2",
    headerClassName: "headingbg-color",
    headerName: "Carrier Name",
  },
  {
    field: "MasterBOLAddress",
    headerClassName: "headingbg-color",
    headerName: "Master BOL Address",
  },
  {
    field: "FreightTerms",
    headerClassName: "headingbg-color",
    headerName: "Freight Terms",
  },
  {
    field: "BillToAccountNumber",
    headerClassName: "headingbg-color",
    headerName: "Bill To Account Number ",
  },
  {
    field: "TP_FreightTermsAddress",
    headerClassName: "headingbg-color",
    headerName: "TP Freight Terms Address",
  },
  {
    field: "TP_FreightTermsCity",
    headerClassName: "headingbg-color",
    headerName: "TP Freight Terms City",
  },
  {
    field: "TP_FreightTermsState",
    headerClassName: "headingbg-color",
    headerName: "TP Freight Terms State",
  },
  {
    field: "TP_FreightTermsZipCode",
    headerClassName: "headingbg-color",
    headerName: "TP Freight Terms Zip Code",
  },
  {
    field: "EnteredBy",
    headerClassName: "headingbg-color",
    headerName: "Entered By",
  },
  {
    field: "RoutingReceivedDate",
    headerClassName: "headingbg-color",
    headerName: "Routing received date",
  },
];

const WaitingForRouting = () => {
  const apiRef = useGridApiRef();
  const [isLoading, setIsLoading] = useState(false);
  const { user, userSetting } = useSelector((state) => state.user);
  const [orderData, setOrderData] = React.useState([]);
  const [routingDate, setRoutingDate] = useState();
  const [shipToName, setShipToName] = useState("");
  const [shipToNameUpdate, setShipToNameUpdate] = useState("");
  const [billToName, setBillToName] = useState("");
  const [clearFormData, setClearFormData] = useState(false);
  const [groupingNumber, setGroupingNumber] = useState("");
  const [poNum, setPoNum] = useState("");
  const [enteredBy, setEnteredBy] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [routingData, setRoutingData] = useState([]);
  const [loadNumber, setLoadNumber] = useState("");
  const [externalLoadNumber, setExternalLoadNumber] = useState("");
  const [bolNotes, setBolNotes] = useState("");
  const [appointmentNumber, setAppointmentNumber] = useState("");
  const [appointmentDateTime, setAppointmentDateTime] = useState();
  const [scac, setScac] = useState("SELECT_CARRIER");
  const [carrierName, setCarrierName] = useState("SELECT_CARRIER");
  const [MBOL_AddressL1, setMBOL_AddressL1] = useState("");
  const [masterShipToName, setMasterShipToName] = useState("");
  const [MBOL_AddressL2, setMBOL_AddressL2] = useState("");
  const [MBOL_City, setMBOL_City] = useState("");
  const [MBOL_State, setMBOL_State] = useState("");
  const [MBOL_Zip, setMBOL_Zip] = useState("");
  const [ShipTo_AddressL1, setShipTo_AddressL1] = useState("");
  const [ShipTo_AddressL2, setShipTo_AddressL2] = useState("");
  const [ShipTo_AddressL3, setShipTo_AddressL3] = useState("");
  const [ShipTo_City, setShipTo_City] = useState("");
  const [ShipTo_State, setShipTo_State] = useState("");
  const [ShipTo_ISOCountryCode, setShipTo_ISOCountryCode] = useState("");
  const [ShipTo_Zip, setShipTo_Zip] = useState("");
  const [FreightTerms, setFreightTerms] = useState("SELECT_FREIGHT");
  const [BillToAccountNumber, setBillToAccountNumber] = useState("");
  const [TP_FreightTermsAddress, setTP_FreightTermsAddress] = useState("");
  const [TP_FreightTermsCity, setTP_FreightTermsCity] = useState("");
  const [TP_FreightTermsState, setTP_FreightTermsState] = useState("");
  const [TP_FreightTermsZipCode, setTP_FreightTermsZipCode] = useState("");
  const [shipTo, setShipTo] = useState("SELECT_SHIPTO");
  const [carriersData, setCarriersData] = useState([]);
  const [shipToData, setShipToData] = useState([]);
  const [apiMsg, setApiMsg] = useState("");
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [freightTermsData, setFreightTermsData] = useState([]);
  const [mustArriveDate, setMustArriveDate] = useState({
    from_mustArriveByDt: "",
    to_mustArriveByDt: "",
  });

  const [scheduleShipDate, setScheduleShipDate] = useState({
    from_startShipDt: "",
    to_startShipDt: "",
  });

  const [enteredDateForRouting, setEnteredDateForRouting] = useState({
    from_dtEnteredForRouting: "",
    to_dtEnteredForRouting: "",
  });

  const [formDialog, setFormDialog] = useState(false);
  const [newShipToDataSaved, setNewShipToDataSaved] = useState(false);
  const [formShipToCode, setFormShipToCode] = useState("");
  const [formShipToName, setFormShipToName] = useState("");
  const [formShipToDesc, setFormShipToDesc] = useState("");
  const [formShipToAddLine1, setFormShipToAddLine1] = useState("");
  const [formShipToAddLine2, setFormShipToAddLine2] = useState("");
  const [formShipToAddLine3, setFormShipToAddLine3] = useState("");
  const [formShipToAddLine4, setFormShipToAddLine4] = useState("");
  const [formShipToCountry, setFormShipToCountry] = useState("");
  const [formShipToState, setFormShipToState] = useState("");
  const [formShipToCity, setFormShipToCity] = useState("");
  const [formShipToZip, setFormShipToZip] = useState("");
  const [formShipToContact1, setFormShipToContact1] = useState("");
  const [formShipToContact2, setFormShipToContact2] = useState("");

  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [rowsData, setRowsData] = useState([]);

  const labelArriveDate = mustArriveDate.from_mustArriveByDt
    ? mustArriveDate.from_mustArriveByDt.format("MMMM D, YYYY") +
      " - " +
      mustArriveDate.to_mustArriveByDt.format("MMMM D, YYYY")
    : "Must arrive by date";

  const labelScheduleShipDate = scheduleShipDate.from_startShipDt
    ? scheduleShipDate.from_startShipDt.format("MMMM D, YYYY") +
      " - " +
      scheduleShipDate.to_startShipDt.format("MMMM D, YYYY")
    : "Order Start Ship Date";

  const labelEnteredRoutingDate = enteredDateForRouting.from_dtEnteredForRouting
    ? enteredDateForRouting.from_dtEnteredForRouting.format("MMMM D, YYYY") +
      " - " +
      enteredDateForRouting.to_dtEnteredForRouting.format("MMMM D, YYYY")
    : "Date entered for routing";

  useEffect(() => {
    const rows = orderData?.map((c, index) => ({
      id: index,
      WHSEID: c.WHSEID,
      CustomerName: c.CustomerName,
      CustomerOrderNumber: c.CustomerOrderNumber,
      IGDOrderNumber: c.IGDOrderNumber,
      CustomerPOnumber: c.CustomerPOnumber,
      orderStatus: c.orderStatus,
      ShipToName: c.ShipToName,
      ShipToAddress: c.ShipToAddress,
      BillToName: c.BillToName,
      OrderShipDate: c.OrderShipDate,
      OrderCancelDate: c.OrderCancelDate,
      ScheduledShipDate: c.ScheduledShipDate,
      QtyOrdered: c.QtyOrdered,
      PcsOrdered: c.PcsOrdered,
      TotalCube: c.TotalCube,
      TotalWeight: c.TotalWeight,
      GroupingNumber: c.GroupingNumber,
      RoutingNotesWithTMS: c.RoutingNotesWithTMS,
      DateEnteredForRouting: c.DateEnteredForRouting,
      LoadNumber: c.LoadNumber,
      ExternalLoadNumber: c.ExternalLoadNumber,
      BOLNotes: c.BOLNotes,
      AppointmentNumber: c.AppointmentNumber,
      AppointmentDateTime: c.AppointmentDateTime,
      SCAC: c.SCAC,
      CarrierName2: c.CarrierName2,
      MasterBOLAddress: c.MasterBOLAddress,
      TP_FreightTermsAddress: c.TP_FreightTermsAddress,
      TP_FreightTermsCity: c.TP_FreightTermsCity,
      TP_FreightTermsState: c.TP_FreightTermsState,
      TP_FreightTermsZipCode: c.TP_FreightTermsZipCode,
      EnteredBy: c.EnteredBy,
      RoutingReceivedDate: c.RoutingReceivedDate,
      FreightTerms: c.FreightTerms,
      BillToAccountNumber: c.BillToAccountNumber,
      isSelectable: true,
    }));
    setRowsData(rows);
  }, [orderData]);

  const fetchOrderTableData = async () => {
    setIsLoading(true);
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };
    let payload = {
      custCode: userSetting[0].currCustomer,
      whseCode: userSetting[0].currWarehouse,
      shipToName: shipToName ? shipToName : "all",
      billToName: billToName ? billToName : "all",
      from_startShipDt: scheduleShipDate.from_startShipDt
        ? scheduleShipDate.from_startShipDt.format("YYYY-MM-DD")
        : "",
      to_startShipDt: scheduleShipDate.to_startShipDt
        ? scheduleShipDate.to_startShipDt.format("YYYY-MM-DD")
        : "",
      from_mustArriveByDt: mustArriveDate.from_mustArriveByDt
        ? mustArriveDate.from_mustArriveByDt.format("YYYY-MM-DD")
        : "",
      to_mustArriveByDt: mustArriveDate.to_mustArriveByDt
        ? mustArriveDate.to_mustArriveByDt.format("YYYY-MM-DD")
        : "",

      groupingNumber: groupingNumber ? groupingNumber : "all",
      from_dtEnteredForRouting: enteredDateForRouting.from_dtEnteredForRouting
        ? enteredDateForRouting.from_dtEnteredForRouting.format("YYYY-MM-DD")
        : "",
      to_dtEnteredForRouting: enteredDateForRouting.to_dtEnteredForRouting
        ? enteredDateForRouting.to_dtEnteredForRouting.format("YYYY-MM-DD")
        : "",
      customerPOnumber: poNum ? poNum : "all",
    };
    const response = await postRequest(
      "user/getOrders_waitingForRouting",
      payload,
      headers
    );

    setClearFormData(false);
    setOrderData(response.data.Payload);
    setIsLoading(false);
    await getCarrierData();
    await getShipToData();
    await getFreightTermsData();
  };

  const handleAddNewShipTo = async () => {
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };

    let payload = {
      whseCode: userSetting[0].currWarehouse,
      shipToCode: formShipToCode,
      shipToName: formShipToName,
      description: formShipToDesc,
      addressL1: formShipToAddLine1,
      addressL2: formShipToAddLine2,
      addressL3: formShipToAddLine3,
      addressL4: formShipToAddLine4,
      country: formShipToCountry,
      state: formShipToState,
      city: formShipToCity,
      zip: formShipToZip,
      contact1: formShipToContact1,
      contact2: formShipToContact2,
      user: "admin",
    };
    const response = await postRequest(
      "user/saveToInfr_shipToDtls",
      payload,
      headers
    );

    await getShipToData();
    setNewShipToDataSaved(true);
    setFormDialog(false);
    resetNewShipToForm();
  };

  const resetNewShipToForm = () => {
    setFormShipToCode("");
    setFormShipToName("");
    setFormShipToDesc();
    setFormShipToAddLine1();
    setFormShipToAddLine2();
    setFormShipToAddLine3();
    setFormShipToAddLine4();
    setFormShipToCountry();
    setFormShipToState();
    setFormShipToCity();
    setFormShipToZip();
    setFormShipToContact1();
    setFormShipToContact2();
  };

  const getCarrierData = async () => {
    const payload = {
      masterListFor: "carriers",
      whseCode: userSetting[0].currWarehouse,
    };
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };
    const response = await postRequest(
      "user/Get_MasListVals",
      payload,
      headers
    );

    setCarriersData(response.data.Payload.Table);
  };

  const getShipToData = async () => {
    const payload = {
      masterListFor: "shipToMas",
      whseCode: userSetting[0].currWarehouse,
    };
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };
    const response = await postRequest(
      "user/Get_MasListVals",
      payload,
      headers
    );

    setShipToData(response.data.Payload.Table);
  };

  const getFreightTermsData = async () => {
    const payload = {
      masterListFor: "paymentTerms",
      whseCode: userSetting[0].currWarehouse,
    };
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };
    const response = await postRequest(
      "user/Get_MasListVals",
      payload,
      headers
    );

    setFreightTermsData(response.data.Payload.Table);
  };

  const getShiptoDetail = async () => {
    if (shipTo === "SELECT_SHIPTO") {
      clearShiptoDetails();
    } else {
      const payload = {
        whseCode: userSetting[0].currWarehouse,
        shipToCode: shipTo,
      };
      let headers = {
        "Content-Type": "application/json;",
        Authorization: `Bearer ${user.token}`,
      };
      const response = await postRequest(
        "user/Get_ShipToMasDtls",
        payload,
        headers
      );
      setShipToDetails(response.data.Payload);
    }
  };

  const setShipToDetails = (data) => {
    if (data.length) {
      let shipTo = data[0];
      setShipToNameUpdate(shipTo.shipToName);
      setShipTo_AddressL1(shipTo.ADDRESS1);
      setShipTo_AddressL2(shipTo.ADDRESS2);
      setShipTo_AddressL3(shipTo.ADDRESS3);
      setShipTo_City(shipTo.CITY);
      setShipTo_State(shipTo.STATE);
      setShipTo_ISOCountryCode(shipTo.ISOCNTRYCODE);
      setShipTo_Zip(shipTo.ZIP);
    }
  };

  const clearShiptoDetails = () => {
    setShipToNameUpdate("");
    setShipTo_AddressL1("");
    setShipTo_AddressL2("");
    setShipTo_AddressL3("");
    setShipTo_City("");
    setShipTo_State("");
    setShipTo_ISOCountryCode("");
    setShipTo_Zip("");
  };

  useEffect(() => {
    getShiptoDetail();
  }, [shipTo]);

  const handleUpdateData = async () => {
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };

    let selectedRows = apiRef.current.getSelectedRows();
    let pushedArrayToString = [];
    for (let [key, value] of selectedRows) {
      console.log(key + " is " + value);
      pushedArrayToString.push(value.IGDOrderNumber);
    }
    let payload = {
      custCode: userSetting[0].currCustomer,
      whseCode: userSetting[0].currWarehouse,
      orderKeys: pushedArrayToString.toString(),
      LoadNumber: loadNumber,
      ExternalLoadNumber: externalLoadNumber,
      BOLNotes: bolNotes,
      AppointmentNumber: appointmentNumber,
      AppointmentDateTime: appointmentDateTime,
      SCAC: carrierName === "SELECT_CARRIER" ? "" : carrierName,
      CarrierName: scac === "SELECT_CARRIER" ? "" : scac,
      MBOL_AddressL1: MBOL_AddressL1,
      MBOL_AddressL2: MBOL_AddressL2,
      MBOL_City: MBOL_City,
      MBOL_State: MBOL_State,
      MBOL_Zip: MBOL_Zip,
      ShipTo_AddressL1: ShipTo_AddressL1,
      ShipTo_AddressL2: ShipTo_AddressL2,
      ShipTo_AddressL3: ShipTo_AddressL3,
      ShipTo_City: ShipTo_City,
      ShipTo_State: ShipTo_State,
      ShipTo_ISOCountryCode: ShipTo_ISOCountryCode,
      ShipTo_Zip: ShipTo_Zip,
      FreightTerms: FreightTerms === "SELECT_FREIGHT" ? "" : FreightTerms,
      BillToAccountNumber: BillToAccountNumber,
      TP_FreightTermsAddress: TP_FreightTermsAddress,
      TP_FreightTermsCity: TP_FreightTermsCity,
      TP_FreightTermsState: TP_FreightTermsState,
      TP_FreightTermsZipCode: TP_FreightTermsZipCode,
      RoutingReceivedDate: routingDate,
      ShipTo_Name: shipToName,
      MBOL_CompanyName: masterShipToName,
      user: "admin",
    };
    const response = await postRequest(
      "user/save_ordersRoutingLoadDtls",
      payload,
      headers
    );

    if (response.data.Payload) {
      fetchOrderTableData();
      setRowSelectionModel([]);
      resetFormData();
      setOpen(true);
      setApiMsg(response.data.Payload[0].message);
      setError(false);
      setDrawerOpen(false);
      // setTimeout(() => {
      //   setOpen(false);
      //   setTimeout(() => {
      //     setApiMsg("");
      //   }, 0);
      // }, 3000);
    } else {
      setApiMsg(response.data.Message);
      setError(true);
      setOpen(true);
      // setTimeout(() => {
      //   setOpen(false);
      // }, 3000);
    }
  };

  const resetFormData = () => {
    setLoadNumber("");
    setExternalLoadNumber("");
    setBolNotes("");
    setAppointmentNumber("");
    setAppointmentDateTime();
    setScac("SELECT_CARRIER");
    setCarrierName("SELECT_CARRIER");
    setMBOL_AddressL1("");
    setMBOL_AddressL2("");
    setMBOL_City("");
    setMBOL_State("");
    setMBOL_Zip("");
    setShipToName("");
    setShipTo_AddressL1("");
    setShipTo_AddressL2("");
    setShipTo_AddressL3("");
    setShipTo_City("");
    setShipTo_State("");
    setShipTo_ISOCountryCode("");
    setShipTo_Zip("");
    setFreightTerms("SELECT_FREIGHT");
    setBillToAccountNumber("");
    setTP_FreightTermsAddress("");
    setTP_FreightTermsCity("");
    setTP_FreightTermsState("");
    setTP_FreightTermsZipCode("");
    setEnteredBy("");
    setRoutingDate();
    setShipTo("SELECT_SHIPTO");
  };

  useEffect(() => {
    fetchOrderTableData();
  }, [userSetting]);

  const handleCallback = (start, end) => {
    setMustArriveDate({ from_mustArriveByDt: start, to_mustArriveByDt: end });
  };

  const handleScheduleShipDateCallback = (start, end) => {
    setScheduleShipDate({ from_startShipDt: start, to_startShipDt: end });
  };

  const handleEnteredDateCallback = (start, end) => {
    setEnteredDateForRouting({
      from_dtEnteredForRouting: start,
      to_dtEnteredForRouting: end,
    });
  };

  const handleSearch = (e) => {
    if (e) {
      e.preventDefault();
    }
    fetchOrderTableData();
  };

  const handleUpdate = () => {
    handleUpdateData();
  };

  const clearForm = () => {
    setScheduleShipDate({ from_startShipDt: "", to_startShipDt: "" });
    setMustArriveDate({ from_mustArriveByDt: "", to_mustArriveByDt: "" });
    setGroupingNumber("");
    setEnteredDateForRouting({
      from_dtEnteredForRouting: "",
      to_dtEnteredForRouting: "",
    });
    setShipToName("");
    setBillToName("");
    setPoNum("");
    setClearFormData(true);
  };
  useEffect(() => {
    if (clearFormData) {
      fetchOrderTableData();
    }
  }, [clearFormData]);

  function CustomToolbar(props) {
    return (
      <GridToolbarContainer {...props}>
        <GridToolbarColumnsButton
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        <GridToolbarFilterButton
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        <GridToolbarDensitySelector
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        {/* <GridToolbarExport /> */}
        <GridToolbarExport
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        {rowSelectionModel.length > 0 && (
          <Button
            onClick={() => {
              resetFormData();

              setApiMsg("");
              setError(false);
              setDrawerOpen(true);
            }}
          >
            Mass Order Update
          </Button>
        )}
        <Box sx={{ flexGrow: 1 }} />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  const toggleDrawer = (newOpen) => () => {
    setDrawerOpen(newOpen);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
    setApiMsg("");
  };

  const handleCellSelectionModelChange = useCallback((newModel) => {
    Object.entries(newModel).forEach(([id, fields]) => {
      if (fields.RoutingNotesWithTMS) {
        const updatedRow = apiRef.current.getRow(id);
        const data = updatedRow.RoutingNotesWithTMS;
        const dataArray = data.split("~");
        setRoutingData(dataArray);
        setOpenPopUp(true);
      }
    });
  }, []);

  return (
    <>
      <div>
        <form onSubmit={handleSearch}>
          <Grid container spacing={1} sx={{ marginTop: "15px" }}>
            <Grid item xs={12} md={1.2}>
              <div>
                <OutlinedInput
                  name="grouping-number"
                  placeholder="Grouping Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  value={groupingNumber}
                  onChange={(e) => setGroupingNumber(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={0.8}>
              <div>
                <OutlinedInput
                  name="cust-po-num"
                  placeholder="Po Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  value={poNum}
                  onChange={(e) => setPoNum(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={1.2}>
              <div>
                <OutlinedInput
                  name="ship-to-name"
                  placeholder="Ship To Name"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  onChange={(e) => setShipToName(e.target.value)}
                  value={shipToName}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={1.2}>
              <div>
                <OutlinedInput
                  name="bill-to-name"
                  placeholder="Bill To Name"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  value={billToName}
                  onChange={(e) => setBillToName(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} md={2.2}>
              <div>
                <DateRangePicker
                  initialSettings={{
                    startDate: mustArriveDate.from_mustArriveByDt
                      ? mustArriveDate.from_mustArriveByDt.toDate()
                      : moment().toDate(),
                    endDate: mustArriveDate.to_mustArriveByDt
                      ? mustArriveDate.to_mustArriveByDt.toDate()
                      : moment().toDate(),
                  }}
                  onCallback={handleCallback}
                >
                  <div
                    id="reportrange"
                    className="box-with-icon filterCalendar"
                  >
                    <span
                      style={{
                        fontSize: "0.8rem",
                        paddingTop: "3px",
                        color: mustArriveDate.from_mustArriveByDt
                          ? "rgba(0, 0, 0, 0.87)"
                          : "#636c72",
                      }}
                    >
                      {labelArriveDate}
                    </span>
                    <CalendarMonthOutlinedIcon />
                  </div>
                </DateRangePicker>
              </div>
            </Grid>
            <Grid item xs={12} md={2.2}>
              <div>
                <DateRangePicker
                  initialSettings={{
                    startDate: scheduleShipDate.from_startShipDt
                      ? scheduleShipDate.from_startShipDt.toDate()
                      : moment().toDate(),
                    endDate: scheduleShipDate.to_startShipDt
                      ? scheduleShipDate.to_startShipDt.toDate()
                      : moment().toDate(),
                  }}
                  onCallback={handleScheduleShipDateCallback}
                  slotProps={{ textField: { placeholder: "tt.mm.jjjj" } }}
                >
                  <div
                    id="reportrange"
                    className="box-with-icon filterCalendar"
                  >
                    <span
                      style={{
                        fontSize: "0.8rem",
                        paddingTop: "3px",
                        color: scheduleShipDate.from_startShipDt
                          ? "rgba(0, 0, 0, 0.87)"
                          : "#636c72",
                      }}
                    >
                      {labelScheduleShipDate}
                    </span>
                    <CalendarMonthOutlinedIcon />
                  </div>
                </DateRangePicker>
              </div>
            </Grid>

            <Grid item xs={12} md={2.2}>
              <div>
                <DateRangePicker
                  initialSettings={{
                    startDate: enteredDateForRouting.from_dtEnteredForRouting
                      ? enteredDateForRouting.from_dtEnteredForRouting.toDate()
                      : moment().toDate(),
                    endDate: enteredDateForRouting.to_dtEnteredForRouting
                      ? enteredDateForRouting.to_dtEnteredForRouting.toDate()
                      : moment().toDate(),
                  }}
                  onCallback={handleEnteredDateCallback}
                  slotProps={{ textField: { placeholder: "tt.mm.jjjj" } }}
                >
                  <div
                    id="reportrange"
                    className="box-with-icon filterCalendar"
                  >
                    <span
                      style={{
                        fontSize: "0.8rem",
                        paddingTop: "3px",
                        color: enteredDateForRouting.from_dtEnteredForRouting
                          ? "rgba(0, 0, 0, 0.87)"
                          : "#636c72",
                      }}
                    >
                      {labelEnteredRoutingDate}
                    </span>
                    <CalendarMonthOutlinedIcon />
                  </div>
                </DateRangePicker>
              </div>
            </Grid>

            <Grid item xs={12} md={0.9}>
              <Stack direction="row" spacing={0}>
                <IconButton
                  aria-label="submit"
                  color="primary"
                  type="submit"
                  onClick={handleSearch}
                >
                  <SearchIcon />
                </IconButton>
                <IconButton
                  aria-label="clear"
                  color="secondry"
                  onClick={clearForm}
                >
                  <ClearIcon />
                </IconButton>
              </Stack>
            </Grid>

            {/* <Grid item xs={12} md={12}>
            <Stack
              direction="row"
              spacing={2}
              sx={{ justifyContent: "flex-end", alignItems: "flex-start" }}
            >
              <Button
                variant="contained"
                onClick={() => setDrawerOpen(true)}
                size="small"
              >
                Mass Update Order
              </Button>
            </Stack>
          </Grid> */}
          </Grid>
        </form>
      </div>
      <div
        style={{
          height: 700,
          width: "100%",
          marginTop: "20px",
          background: "#fff",
        }}
      >
        <DataGridPremium
          loading={isLoading}
          apiRef={apiRef}
          columns={columns}
          rows={rowsData}
          slots={{ toolbar: CustomToolbar }}
          sx={{
            "& .MuiDataGrid-detailPanel": {
              overflow: "visible",
            },
            "& .MuiButton-text": { fontSize: "14px" },
            ".MuiDataGrid-aggregationColumnHeaderLabel": {
              display: "none",
            },
            "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
              display: "none",
              backgroundColor: 'rgb(103 130 219)'
            }
          }}
          pinnedColumns={{ left: [GRID_DETAIL_PANEL_TOGGLE_FIELD] }}
          pagination
          pageSizeOptions={[30, 50, 100, 200]}
          initialState={{
            pagination: { paginationModel: { pageSize: 50 } },
            aggregation: {
              model: {
                QtyOrdered: "sum",
                PcsOrdered: "sum",
                TotalCube: "sum",
                TotalWeight: "sum",
              },
            },
          }}
          checkboxSelection
          disableRowSelectionOnClick
          onRowSelectionModelChange={(newRowSelectionModel, detail) => {
            let newModel = [];
            let sameLoadData = rowsData;
            if (newRowSelectionModel.length > rowSelectionModel.length) {
              const GroupingNumber = detail.api.getRow(
                newRowSelectionModel[0]
              ).GroupingNumber;
              const filterLoadData = rowsData.filter(
                (data) => data.GroupingNumber === GroupingNumber
              );
              sameLoadData = rowsData.map((data) => {
                if (data.GroupingNumber === GroupingNumber) {
                  return {
                    ...data,
                    isSelectable: true,
                  };
                } else {
                  return {
                    ...data,
                    isSelectable: false,
                  };
                }
              });

              //rows = sameLoadData

              newModel = filterLoadData.map((data) => data.id);
            } else {
              newModel = [];
              sameLoadData = rowsData.map((data) => {
                return {
                  ...data,
                  isSelectable: true,
                };
              });
            }
            setRowSelectionModel(newModel);
            setRowsData(sameLoadData);
          }}
          rowSelectionModel={rowSelectionModel}
          onCellSelectionModelChange={handleCellSelectionModelChange}
          cellSelection={true}
          isRowSelectable={(params) => params.row.isSelectable}
        />
      </div>
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          severity={!error && apiMsg ? "success" : "error"}
          variant="filled"
          sx={{ width: "100%" }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          {apiMsg}
        </Alert>
      </Snackbar>

      <Drawer open={drawerOpen} onClose={toggleDrawer(false)} anchor="right">
        <div className="filter-drawer">
          <div className="filter-header-wrap">
            <span>Update Order Details</span>
            <IconButton aria-label="close" onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12} sx={{ fontSize: "0.9rem", marginTop: "2rem" }}>
              <FormLabel htmlFor="load-number">
                Load Number <span style={{ color: "red" }}>*</span>
              </FormLabel>
              <div>
                <OutlinedInput
                  name="load-number"
                  placeholder="Load Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={loadNumber}
                  onChange={(e) => setLoadNumber(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="external-load-number">
                External Load Number
              </FormLabel>
              <div>
                <OutlinedInput
                  name="external-load-number"
                  placeholder="External Load Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={externalLoadNumber}
                  onChange={(e) => setExternalLoadNumber(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="bol-notes">BOL Notes</FormLabel>
              <div>
                <OutlinedInput
                  name="bol-notes"
                  placeholder="BOL Notes"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={bolNotes}
                  onChange={(e) => setBolNotes(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Appointment-Number">
                Appointment Number
              </FormLabel>
              <div>
                <OutlinedInput
                  name="Appointment-Number"
                  placeholder="Appointment Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={appointmentNumber}
                  onChange={(e) => setAppointmentNumber(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Appointment-Time">
                Appointment Time <span style={{ color: "red" }}>*</span>
              </FormLabel>
              <div>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    label=""
                    value={appointmentDateTime}
                    className="ml-8"
                    onChange={(newDailyValue) =>
                      setAppointmentDateTime(newDailyValue)
                    }
                    slotProps={{
                      textField: {
                        size: "small",
                        height: "0.3rem",
                        placeholder: "Appointment Time",
                        fullWidth: true,
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        padding: "1px 10px 1px 0px",
                        // border: "1px solid #d1d4e2",
                      },
                      height: "0.3rem",
                    }}
                    slots={{ openPickerIcon: CalendarMonthOutlinedIcon }}
                  />
                </LocalizationProvider>
              </div>
            </Grid>

            {/* <Grid item xs={12} sx={{ fontSize: "0.9rem", marginTop: "2rem" }}>
              <FormLabel htmlFor="SCAC">SCAC</FormLabel>
              <div>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={scac}
                  label="Age"
                  onChange={(e) => setScac(e.target.value)}
                  fullWidth
                >
                  <MenuItem value={"SELECT_SCAC"}>{"Select SCAC"}</MenuItem>
                  {carriersData.map((data) => (
                    <MenuItem value={data.value}>{data.text}</MenuItem>
                  ))}
                </Select>
              </div>
            </Grid> */}

            <Grid item xs={12} sx={{ fontSize: "0.9rem", marginTop: "1.5rem" }}>
              <FormLabel htmlFor="Carrier-Name">Select Carrier</FormLabel>
              <div>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={carrierName}
                  label="Age"
                  onChange={(e, el) => {
                    setScac(el.props.children);
                    setCarrierName(e.target.value);
                  }}
                  fullWidth
                >
                  <MenuItem value={"SELECT_CARRIER"}>
                    {"Select Carrier"}
                  </MenuItem>
                  {carriersData.map((data, index) => (
                    <MenuItem value={data.value} key={index}>
                      {data.text}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Master-BOL-Address-Line1">
                Master ShipTo Name
              </FormLabel>
              <div>
                <OutlinedInput
                  name="Master-BOL-Address-Line1"
                  placeholder="Master ShipTo Name"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={masterShipToName}
                  onChange={(e) => setMasterShipToName(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Master-BOL-Address-Line1">
                Master BOL Address Line 1
              </FormLabel>
              <div>
                <OutlinedInput
                  name="Master-BOL-Address-Line1"
                  placeholder="Master BOL Address Line 1"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={MBOL_AddressL1}
                  onChange={(e) => setMBOL_AddressL1(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Master-BOL-Address-Line2">
                Master BOL Address Line 2
              </FormLabel>
              <div>
                <OutlinedInput
                  name="Master-BOL-Address-Line2"
                  placeholder="Master BOL Address Line 2"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={MBOL_AddressL2}
                  onChange={(e) => setMBOL_AddressL2(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Master-BOL-City">Master BOL City</FormLabel>
              <div>
                <OutlinedInput
                  name="Master-BOL-City"
                  placeholder="Master BOL City"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={MBOL_City}
                  onChange={(e) => setMBOL_City(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Master-BOL-State">Master BOL State</FormLabel>
              <div>
                <OutlinedInput
                  name="Master-BOL-State"
                  placeholder="Master BOL State"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={MBOL_State}
                  onChange={(e) => setMBOL_State(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Master-BOL-Zip">Master BOL Zip</FormLabel>
              <div>
                <OutlinedInput
                  name="Master-BOL-Zip"
                  placeholder="Master BOL Zip"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={MBOL_Zip}
                  onChange={(e) => setMBOL_Zip(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <FormLabel htmlFor="Carrier-Name">Select Ship To</FormLabel>
                <Tooltip title="Add New Ship To">
                  <IconButton
                    color="primary"
                    aria-label="add to shopping cart"
                    onClick={() => {
                      resetNewShipToForm();
                      setFormDialog(true);
                      setNewShipToDataSaved(false);
                    }}
                  >
                    <AddCircleOutlineIcon />
                  </IconButton>
                </Tooltip>
              </Stack>

              <div>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={shipTo}
                  label="Age"
                  onChange={(e) => setShipTo(e.target.value)}
                  fullWidth
                >
                  <MenuItem value={"SELECT_SHIPTO"}>
                    {"Select Ship To"}
                  </MenuItem>
                  {shipToData.map((data, index) => (
                    <MenuItem value={data.value} key={index}>
                      {data.text}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Ship-To-Name">Ship To Name</FormLabel>
              <div>
                <OutlinedInput
                  name="Ship-To-Name"
                  placeholder="Ship To Name"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={shipToNameUpdate}
                  onChange={(e) => setShipToNameUpdate(e.target.value)}
                  disabled
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Ship-To-Address-Line1">
                Ship To Address Line 1
              </FormLabel>
              <div>
                <OutlinedInput
                  name="Ship-To-Address-Line1"
                  placeholder="Ship To Address Line 1"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={ShipTo_AddressL1}
                  onChange={(e) => setShipTo_AddressL1(e.target.value)}
                  disabled
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Ship-To-Address-Line2">
                Ship To Address Line 2
              </FormLabel>
              <div>
                <OutlinedInput
                  name="Ship-To-Address-Line2"
                  placeholder="Ship To Address Line 2"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={ShipTo_AddressL2}
                  onChange={(e) => setShipTo_AddressL2(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Ship-To-Address-Line3">
                Ship To Address Line 3
              </FormLabel>
              <div>
                <OutlinedInput
                  name="Ship-To-Address-Line3"
                  placeholder="Ship To Address Line 3"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={ShipTo_AddressL3}
                  onChange={(e) => setShipTo_AddressL3(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Ship-To-City">Ship To City</FormLabel>
              <div>
                <OutlinedInput
                  name="Ship-To-City"
                  placeholder="Ship To City"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={ShipTo_City}
                  onChange={(e) => setShipTo_City(e.target.value)}
                  disabled
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Ship-To-State">Ship To State</FormLabel>
              <div>
                <OutlinedInput
                  name="Ship-To-State"
                  placeholder="Ship To State"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={ShipTo_State}
                  onChange={(e) => setShipTo_State(e.target.value)}
                  disabled
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Ship-To-ISO-Country-Code">
                Ship To ISO Country Code
              </FormLabel>
              <div>
                <OutlinedInput
                  name="Ship-To-ISO-Country-Code"
                  placeholder="Ship To ISO Country Code"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={ShipTo_ISOCountryCode}
                  onChange={(e) => setShipTo_ISOCountryCode(e.target.value)}
                  disabled
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Ship-To-ZIP">Ship To Zip</FormLabel>
              <div>
                <OutlinedInput
                  name="Ship-To-ZIP"
                  placeholder="Ship To Zip"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={ShipTo_Zip}
                  onChange={(e) => setShipTo_Zip(e.target.value)}
                  disabled
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Freight-Terms">Freight Terms</FormLabel>

              <div>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={FreightTerms}
                  label="Age"
                  onChange={(e) => setFreightTerms(e.target.value)}
                  fullWidth
                >
                  <MenuItem value="SELECT_FREIGHT">
                    {"Select Freight Terms"}
                  </MenuItem>
                  {freightTermsData.map((data, index) => (
                    <MenuItem value={data.value} key={index}>
                      {data.text}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              {/* <div>
                <OutlinedInput
                  name="Freight-Terms"
                  placeholder="Freight Terms"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={FreightTerms}
                  onChange={(e) => setFreightTerms(e.target.value)}
                />
              </div> */}
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="Bill-To-Account-Number">
                Bill To Account Number
              </FormLabel>
              <div>
                <OutlinedInput
                  name="Bill-To-Account-Number"
                  placeholder="Bill To Account Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={BillToAccountNumber}
                  onChange={(e) => setBillToAccountNumber(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="TP-Freight-Terms-Address">
                TP Freight Terms Address
              </FormLabel>
              <div>
                <OutlinedInput
                  name="TP-Freight-Terms-Address"
                  placeholder="TP Freight Terms Address"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={TP_FreightTermsAddress}
                  onChange={(e) => setTP_FreightTermsAddress(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="TP-Freight-Terms-City">
                TP Freight Terms City
              </FormLabel>
              <div>
                <OutlinedInput
                  name="TP-Freight-Terms-City"
                  placeholder="TP Freight Terms City"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={TP_FreightTermsCity}
                  onChange={(e) => setTP_FreightTermsCity(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="TP-Freight-Terms-State">
                TP Freight Terms State
              </FormLabel>
              <div>
                <OutlinedInput
                  name="TP-Freight-Terms-State"
                  placeholder="TP Freight Terms State"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={TP_FreightTermsState}
                  onChange={(e) => setTP_FreightTermsState(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="TP-Freight-Terms-Zip">
                TP Freight Terms Zip Code
              </FormLabel>
              <div>
                <OutlinedInput
                  name="TP-Freight-Terms-Zip"
                  placeholder="TP Freight Terms Zip Code"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={TP_FreightTermsZipCode}
                  onChange={(e) => setTP_FreightTermsZipCode(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="entered-by">Entered By</FormLabel>
              <div>
                <OutlinedInput
                  name="entered-by"
                  placeholder="Entered By"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={enteredBy}
                  onChange={(e) => setEnteredBy(e.target.value)}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="date-for-routing">
                Routing Received Date <span style={{ color: "red" }}>*</span>
              </FormLabel>
              <div>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label=""
                    format="YYYY-MM-DD"
                    value={routingDate}
                    className="ml-8"
                    onChange={(newDailyValue) => setRoutingDate(newDailyValue)}
                    slotProps={{
                      textField: {
                        size: "small",
                        height: "0.3rem",
                        placeholder: "Routing Date",
                        fullWidth: true,
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        padding: "1px 10px 1px 0px",
                        // border: "1px solid #d1d4e2",
                      },
                      height: "0.3rem",
                    }}
                    slots={{ openPickerIcon: CalendarMonthOutlinedIcon }}
                  />
                </LocalizationProvider>
              </div>
            </Grid>

            <Grid item xs={12} md={12} sx={{ marginTop: "25px" }}>
              <Button
                variant="contained"
                onClick={handleUpdate}
                size="small"
                disabled={!appointmentDateTime || !loadNumber || !routingDate}
              >
                Update
              </Button>
            </Grid>
          </Grid>
        </div>
      </Drawer>

      {openPopUp && (
        <Box sx={{ width: "100%", height: "200px" }}>
          <Dialog
            open={openPopUp}
            onClose={() => setOpenPopUp(false)}
            aria-labelledby="form-dialog-title"
            style={{
              height: "100%",
              width: "100%",
              alignItems: "center",
            }}
            fullWidth={true}
            maxWidth={"sm"}
          >
            <DialogTitle
              className="colordivSumHead font-bold"
              id="form-dialog-title"
            >
              Routing Notes:
            </DialogTitle>
            <DialogContent>
              {
                <ul style={{ margin: "0", padding: "0", listStyle: "none" }}>
                  {routingData.map((data, index) => (
                    <li style={{ paddingBottom: "5px" }} key={index}>
                      {data}
                    </li>
                  ))}
                </ul>
              }
            </DialogContent>
          </Dialog>
        </Box>
      )}

      {formDialog && (
        <Dialog
          open={formDialog}
          onClose={() => setFormDialog(false)}
          PaperProps={{
            component: "form",
          }}
          maxWidth="sm"
          fullWidth={true}
        >
          <DialogTitle>Add New Ship To</DialogTitle>
          <DialogContent>
            {newShipToDataSaved && (
              <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                Data Saved Succefully
              </Alert>
            )}

            <Box sx={{ marginBottom: 2 }}>
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-radio-buttons-group-label">
                  Ship To Code
                </FormLabel>
                <TextField
                  variant="outlined"
                  placeholder="Ship To Code"
                  onChange={(e) => setFormShipToCode(e.target.value)}
                  value={formShipToCode}
                  fullWidth
                />
              </FormControl>
            </Box>

            <Box sx={{ marginBottom: 2 }}>
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-radio-buttons-group-label">
                  Ship To Name
                </FormLabel>
                <TextField
                  variant="outlined"
                  placeholder="Ship To Name"
                  onChange={(e) => setFormShipToName(e.target.value)}
                  value={formShipToName}
                  fullWidth
                />
              </FormControl>
            </Box>

            <Box sx={{ marginBottom: 2 }}>
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-radio-buttons-group-label">
                  Description
                </FormLabel>
                <TextField
                  variant="outlined"
                  placeholder="Description"
                  onChange={(e) => setFormShipToDesc(e.target.value)}
                  value={formShipToDesc}
                  fullWidth
                />
              </FormControl>
            </Box>

            <Box sx={{ marginBottom: 2 }}>
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-radio-buttons-group-label">
                  Ship To Address Line 1
                </FormLabel>
                <TextField
                  variant="outlined"
                  placeholder="Ship To Address Line 1"
                  onChange={(e) => setFormShipToAddLine1(e.target.value)}
                  value={formShipToAddLine1}
                  fullWidth
                />
              </FormControl>
            </Box>

            <Box sx={{ marginBottom: 2 }}>
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-radio-buttons-group-label">
                  Ship To Address Line 2
                </FormLabel>
                <TextField
                  variant="outlined"
                  placeholder="Ship To Address Line 2"
                  onChange={(e) => setFormShipToAddLine2(e.target.value)}
                  value={formShipToAddLine2}
                  fullWidth
                />
              </FormControl>
            </Box>

            <Box sx={{ marginBottom: 2 }}>
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-radio-buttons-group-label">
                  Ship To Address Line 3
                </FormLabel>
                <TextField
                  variant="outlined"
                  placeholder="Ship To Address Line 3"
                  onChange={(e) => setFormShipToAddLine3(e.target.value)}
                  value={formShipToAddLine3}
                  fullWidth
                />
              </FormControl>
            </Box>

            <Box sx={{ marginBottom: 2 }}>
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-radio-buttons-group-label">
                  Ship To Address Line 4
                </FormLabel>
                <TextField
                  variant="outlined"
                  placeholder="Ship To Address Line 4"
                  onChange={(e) => setFormShipToAddLine4(e.target.value)}
                  value={formShipToAddLine4}
                  fullWidth
                />
              </FormControl>
            </Box>

            <Box sx={{ marginBottom: 2 }}>
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-radio-buttons-group-label">
                  Ship To Country
                </FormLabel>
                <TextField
                  variant="outlined"
                  placeholder="Ship To Country"
                  onChange={(e) => setFormShipToCountry(e.target.value)}
                  value={formShipToCountry}
                  fullWidth
                />
              </FormControl>
            </Box>

            <Box sx={{ marginBottom: 2 }}>
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-radio-buttons-group-label">
                  Ship To State
                </FormLabel>
                <TextField
                  variant="outlined"
                  placeholder="Ship To State"
                  onChange={(e) => setFormShipToState(e.target.value)}
                  value={formShipToState}
                  fullWidth
                />
              </FormControl>
            </Box>

            <Box sx={{ marginBottom: 2 }}>
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-radio-buttons-group-label">
                  Ship To City <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <TextField
                  variant="outlined"
                  placeholder="Ship To City"
                  onChange={(e) => setFormShipToCity(e.target.value)}
                  value={formShipToCity}
                  fullWidth
                />
              </FormControl>
            </Box>

            <Box sx={{ marginBottom: 2 }}>
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-radio-buttons-group-label">
                  Ship To Zip <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <TextField
                  variant="outlined"
                  placeholder="Ship To Zip"
                  onChange={(e) => setFormShipToZip(e.target.value)}
                  value={formShipToZip}
                  fullWidth
                />
              </FormControl>
            </Box>

            <Box sx={{ marginBottom: 2 }}>
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-radio-buttons-group-label">
                  Ship To Contact 1
                </FormLabel>
                <TextField
                  variant="outlined"
                  placeholder="Ship To Contact 1"
                  onChange={(e) => setFormShipToContact1(e.target.value)}
                  value={formShipToContact1}
                  fullWidth
                />
              </FormControl>
            </Box>

            <Box sx={{ marginBottom: 2 }}>
              <FormControl sx={{ width: "100%" }}>
                <FormLabel id="demo-radio-buttons-group-label">
                  Ship To Contact 2
                </FormLabel>
                <TextField
                  variant="outlined"
                  placeholder="Ship To Contact 2"
                  onChange={(e) => setFormShipToContact2(e.target.value)}
                  value={formShipToContact2}
                  fullWidth
                />
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setFormDialog(false)}
              sx={{ fontSize: "13px" }}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              type="button"
              onClick={handleAddNewShipTo}
              sx={{ fontSize: "13px" }}
              variant="contained"
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default WaitingForRouting;
